export default "__VITE_ASSET__6b6fe243__"